import * as gamMethods from '../../consts/gam/gamMethods';
import {makeSelectIsHolderByAssetId} from '../../state/selectors/yapEncrypted';
import {dispatch, getState} from '../../state/store';
import arrayUtils from '../../utils/arrayUtils';
import stringUtils from '../../utils/stringUtils';
import log from '../logger/log';
import server from '../server/server';

//don't call YapClient. Use UamClient or GamClient instead!!!
export default class YapClient {
    tokenRefreshInProgress = false;
    holderTokenRefreshInProgress = false;

    setTokenRefreshInProgress = (isHolder, value) => {
        if (isHolder) {
            this.holderTokenRefreshInProgress = value;
        } else {
            this.tokenRefreshInProgress = value;
        }
    };

    isTokenRefreshInProgress = (isHolder) => {
        if (isHolder) {
            return this.holderTokenRefreshInProgress;
        }

        return this.tokenRefreshInProgress;
    };

    //abstract methods
    getHeaders = async () => {};
    errorCheck = async () => {};
    getRequestParams = async () => {};
    getApiUrl = () => {};

    getMethodUrl = ({methodName, requestConfig}) => {
        const args = requestConfig?.args;
        let methodUrl = methodName;

        if (args) {
            const params = arrayUtils.toArray(args);

            methodUrl = stringUtils.formatString(methodName, ...params);
        }
        return methodUrl;
    };

    callGet = (options) => {
        options.methodUrl = this.getMethodUrl(options);
        options.httpMethod = server.get;
        return this.callRequest(options);
    };

    callPost = (options) => {
        options.methodUrl = this.getMethodUrl(options);
        options.httpMethod = server.post;
        return this.callRequest(options);
    };

    callPut = (options) => {
        options.methodUrl = this.getMethodUrl(options);
        options.httpMethod = server.put;
        return this.callRequest(options);
    };

    callRequest = async (params) => {
        try {
            const response = await this.callMethod(params);

            if (!response) return null;

            const {action, mapper} = params;
            let {data} = response;

            if (mapper) {
                data = mapper(data);
            }

            if (action) {
                dispatch(action(data));
            } else {
                return data;
            }
        } catch (e) {
            return null;
        }
    };

    callMethod = async ({
        httpMethod,
        methodUrl,
        requestConfig,
        ignoreErrorCodes,
        isNeedRedirectForOtherErrors,
        isHolder,
        codentify,
    }) => {
        const url = this.getApiUrl(methodUrl);
        const args = requestConfig?.args;
        const getAssetId = () => (Array.isArray(args) ? args[0] : args);
        const isHolderAssetId = makeSelectIsHolderByAssetId(getAssetId())(getState());
        const isHolderCall = isHolder || isHolderAssetId;
        const headers = requestConfig?.headers ? requestConfig.headers : await this.getHeaders(isHolderCall);
        const params = requestConfig?.params ? requestConfig?.params : {};
        const data = requestConfig?.data ? requestConfig.data : {};

        try {
            const response = await httpMethod(url, {headers, params, data});

            log.debug(`yapClient: request: '${methodUrl}' has successful response`);

            return response;
        } catch (e) {
            return await this.errorCheck(
                e,
                methodUrl,
                async ({refreshedAuthToken}) => {
                    if (!refreshedAuthToken) return;

                    if (methodUrl.includes(gamMethods.REFRESH_TOKEN_PATH)) return {data: true};

                    const uamParams = await this.getRequestParams(
                        headers,
                        params,
                        data,
                        isHolderCall,
                        refreshedAuthToken
                    );

                    if (!uamParams) return;

                    return await httpMethod(url, uamParams);
                },
                ignoreErrorCodes,
                isNeedRedirectForOtherErrors,
                isHolderCall,
                codentify
            );
        }
    };
}
